import React, {useEffect, useState} from 'react';
import {DownloadIcon, UploadIcon} from "../../../assets/icons/Icons";
import UploadButton from "../../form/UploadButton";
import CsvUploadLoaderBackground from "../../../assets/images/loading-data-placeholder.png";
import {BulkCreateCardholdersTemplateInfo, DownloadCardholderCsvTemplate} from "../../../api";
import {useTranslation} from "react-i18next";

const UploadCsv = ({ setUploadedTemplate }) => {

    const { t } = useTranslation();

    const [templateInfoLoding, setTemplateInfoLoading] = useState(false);
    const [templateInfo, setTemplateInfo] = useState([]);

    const handleDownloadButtonClick = async (e) => {
        try {
            await DownloadCardholderCsvTemplate();
        } catch (error) {
            console.error('Failed to download the template:', error);
        }
    }

    useEffect(() => {
        const requestTemplateInfo = async () => {
            try {
                setTemplateInfoLoading(true);
                setTemplateInfo(await BulkCreateCardholdersTemplateInfo());
                setTemplateInfoLoading(false);
            } catch (err) {
                console.log(err);
            }

        }
        requestTemplateInfo();
    }, []);

    return (
        <div className="step">
            <div className="upload-csv">
                <div className="row mb-2">
                    <div className="col-xs-8">
                        <p>{t("To begin, please download the spreadsheet form and fill it out with your cardholder details. When complete, upload the file and your cardholder entries will be listed below.")}</p>
                    </div>
                    <div className="col-xs-4 text-right">
                        <button onClick={e => handleDownloadButtonClick(e)}
                                className="btn btn-secondary btn-medium">
                            <DownloadIcon/>
                            {t("Download")}
                        </button>
                        <UploadButton accept=".csv" class="btn btn-primary btn-medium ml-2" title={<><UploadIcon/>{t("Upload CSV")}</>} onChange={e => setUploadedTemplate(e)}/>
                    </div>
                </div>
                <h4>{t("CSV Field Details")}</h4>
                {templateInfoLoding ? <img src={CsvUploadLoaderBackground} alt="loading data"/> : (
                    templateInfo && (
                        <>
                            <div className="overflow-x-auto data-table small-data-table mb-4">
                                <table>
                                    <thead>
                                    <tr>
                                        <th>{t("Field")}</th>
                                        <th>{t("Required")}</th>
                                        <th>{t("Requirements")}</th>
                                        <th>{t("Notes")}</th>
                                        <th>{t("Example")}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {templateInfo.map((item, index) => (
                                        <tr key={index}>
                                            <td>{item.Field}</td>
                                            <td>{item.Required}</td>
                                            <td>{item.Requirements}</td>
                                            <td>{item.Notes}</td>
                                            <td>{item.Example}</td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </div>
                        </>
                    )
                )}
            </div>
        </div>
    );
};

export default UploadCsv;
